import { Fragment } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Empty as AntdEmpty, Button } from 'antd';
import styled from 'styled-components';
import { DashboardProcsContext } from '@/entities/proc';
import { useAuth } from '@/features/auth';
import { api, ProcDetailsResponse } from '@/shared/api';
import { useRouterPrivateContext } from '@/shared/router';
import { ProcCard } from '@/widgets/proc-card';
import EmptyIcon from '@assets/empty.svg';

const PROCS_PER_PAGE = 50;

export const MyInstances = () => {
  const { accessToken } = useAuth();
  const { selectedCategory } = useRouterPrivateContext();

  async function fetchProcs({ pageParam = 1 }) {
    return await api.get(`/procs/instances/list/my`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        page: pageParam,
        take: PROCS_PER_PAGE,
      },
    });
  }
  const {
    data: procsData,
    refetch: refetchProcs,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: [
      'myInstancesGetPaginated',
      //   debouncedValue,
    ],
    queryFn: fetchProcs,
    keepPreviousData: true,
    getNextPageParam: ({ data }) => {
      if (data.meta.hasNextPage) {
        return data.meta.page + 1;
      }
      return false;
    },
    enabled: Boolean(selectedCategory === 'myInstances' && accessToken),
  });

  if (!procsData) {
    return null;
  }

  return procsData?.pages[0]?.data?.data.length &&
    selectedCategory === 'myInstances' ? (
    <DashboardProcsContext.Provider value={{ refetchProcs }}>
      <>
        <Grid>
          {procsData?.pages.map((page, pagesIndex) => (
            <Fragment key={pagesIndex}>
              {page.data.data.map((item: ProcDetailsResponse) => (
                <ProcCard key={item.id} type={selectedCategory} proc={item} />
              ))}
            </Fragment>
          ))}
        </Grid>
        {hasNextPage && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '50px 0 20px 0',
            }}
          >
            <Button type="primary" onClick={() => fetchNextPage()}>
              Load more
            </Button>
          </div>
        )}
      </>
    </DashboardProcsContext.Provider>
  ) : (
    <Empty
      image={EmptyIcon}
      styles={{ image: { height: '100%', maxHeight: 180, marginInline: 0 } }}
      description="There are no procs to show"
      style={{
        width: '100%',
        height: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    />
  );
};

const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  grid-gap: 20px;
  align-items: stretch;
`;

const Empty = styled(AntdEmpty)`
  margin-inline: 0px;
`;
